import React from "react";
import {
  HelpDeskTicket,
  HelpDeskTicketStatus,
  HelpDeskTicketStatusTranslation,
} from "../../types/help_desk_tickets.types";
import Label from "../../components/label";
import { Button } from "../../components/button";

interface HDTDetailProps {
  hdTicket: HelpDeskTicket;
  onBack: () => void;
}

export const HDTDetail: React.FC<HDTDetailProps> = ({ hdTicket, onBack }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800">
          {hdTicket.title}
        </h2>
        <Label
          color={
            hdTicket.status === HelpDeskTicketStatus.Pending
              ? "yellow"
              : "green"
          }
          fontSize="sm"
        >
          {HelpDeskTicketStatusTranslation[hdTicket.status]}
        </Label>
      </div>

      <div className="text-sm text-gray-500 mb-3">
        Enviado el {new Date(hdTicket.created_at).toLocaleDateString()}
      </div>

      <div
        className={`border-l-4 ${
          hdTicket.status === HelpDeskTicketStatus.Resolved
            ? "border-green-500"
            : "border-yellow-500"
        } pl-4 py-1`}
      >
        <p className="text-gray-700 whitespace-pre-line">
          {hdTicket.description || "No se proporcionó descripción."}
        </p>

        {hdTicket.status === HelpDeskTicketStatus.Resolved &&
          hdTicket.response &&
          hdTicket.closed_at && (
            <div className="mt-8 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                Respuesta
              </h3>

              <div className="flex justify-between items-center mb-2">
                <div className="text-xs text-gray-500">
                  Respondido el{" "}
                  {new Date(hdTicket.closed_at).toLocaleDateString()}
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-md">
                <p className="text-gray-700 whitespace-pre-line">
                  {hdTicket.response}
                </p>
              </div>
            </div>
          )}
      </div>

      <Button
        variant="back"
        onClick={onBack}
        className="mt-6"
        text="Volver atrás"
      />
    </div>
  );
};
